import React, { useState } from "react";
import Spinner from './Spinner';

const CollapsiblePanel = ({
                              title,
                              previewContent,
                              renderContent,
                              onFetch,
                              onExpand,
                              requireAuth = false,
                              isUserLogged = false,
                              loaderComponent: LoaderComponent
                          }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {
        const willExpand = !isExpanded;

        if (willExpand) {
            if (requireAuth && !isUserLogged) {
                onExpand?.();
                return;
            }

            // Expand immediately to show the loader
            setIsExpanded(true);

            if (onFetch) {
                setLoading(true);
                await onFetch();
                setLoading(false);
            }
        } else {
            // Collapse the panel
            setIsExpanded(false);
        }
    };

    return (
        <div className="bg-white shadow-md rounded-lg mb-4 p-4">
            <button
                className="w-full text-left font-semibold text-gray-800 text-lg flex justify-between items-center"
                onClick={handleToggle}
            >
                <span>{title}</span>
                <span>{isExpanded ? "▲" : "▼"}</span>
            </button>

            {!isExpanded && (
                <p className="text-gray-500 text-sm mt-2 line-clamp-2 opacity-50">
                    {previewContent}
                </p>
            )}

            {isExpanded && (
                <div className="mt-3">
                    {loading ? (
                        <div className="flex items-center justify-center p-6">
                            {LoaderComponent ? <LoaderComponent /> : <Spinner text="Cargando datos..." />}
                        </div>
                    ) : (
                        renderContent?.()
                    )}
                </div>
            )}
        </div>
    );
};

export default CollapsiblePanel;
